import React, { useRef, useState, useEffect } from 'react';
import { Trash2 } from 'lucide-react';

import { Popup } from 'devextreme-react/popup';
import { confirm } from 'devextreme/ui/dialog';
import { useDispatch, useSelector } from 'react-redux'
import { dialogBillPaymentAction } from '../../store/billPayment/billPaymentDialogReducer';
import { Button, NumberBox, ScrollView, SelectBox, TextBox } from 'devextreme-react';
import List from 'devextreme-react/list';
import http from '../../utils/http';
import { formatToMoneyNumber } from '../../utils/common';

const BillPayments = (props) => {

    const { open, id, amount = 0, payments } = useSelector(store => store.billPaymentDialog);
    const [tiposPago, setTiposPago] = useState([]);
    const [banks, setBanks] = useState([]);
    const [paymentList, setPaymentList] = useState([...payments]);
    const [saldoPendiente, setSaldoPendiente] = useState(amount);
    const [cambio, setCambio] = useState(0);

    const [formData, setFormData] = useState({
        paymentMethodId: 1,
        bankId: null,
        reference: '',
        paymentAmount: null,
        changeAmount: 0
    });

    const loadCatalogs = async () => {

        if(tiposPago.length > 0 && banks.length > 0) return;

        const [tiposPagoData, banksData] = await Promise.all([
            http('catalogos/BillPaymentMethod').asGet(),
            http('catalogos/Bank').asGet()
        ]);
        setTiposPago(tiposPagoData);
        setBanks(banksData);
    };

    const refCatalog = useRef();
    const dispatch = useDispatch();

    const closeDialog = (load) => {

        dispatch(dialogBillPaymentAction({ open: false, id: 0, payments: [], amount: 0 }));        

        if (load) {
            let { onSave } = props;

            let _paymentList = [...paymentList.map(p => {
                p.changeAmount = 0;
                return p;
            })];
            
            if(cambio > 0){
                //apply change to payment where Tipo de Pago = 1
                let efectivoPayment = _paymentList.find(p => p.paymentMethodId === 1);
                if(efectivoPayment){
                    efectivoPayment.changeAmount = cambio;
                }
            }       

            onSave(load, _paymentList);
        }
    }

    useEffect(() => {
        loadCatalogs();
        if(id == 0)
        {
            setPaymentList([]);
            setCambio(0);
        }
    }, [id]);

   const onHiding = ({ load }) => {

        closeDialog(load);

    }

    const resetForm = () => {
        setFormData({
            paymentMethodId: 1,
            bankId: null,
            reference: '',
            paymentAmount: 0,
            changeAmount: 0
        });
    };

    const handleAddPayment = () => {
        setPaymentList([...paymentList, { ...formData, id: Date.now() }]);
        resetForm();
    };

    useEffect(() => {
        let newSaldo = amount - paymentList.reduce((acc, item) => acc + item.paymentAmount, 0);
        if (newSaldo <= 0) {
            setCambio(-newSaldo);
            newSaldo = 0;
        }
        setSaldoPendiente(newSaldo);
    }, [paymentList]);

    const handleRemovePayment = (id) => {
        setPaymentList(paymentList.filter((item) => item.id !== id));
    };

    const handleConfirmPayments = () => {
        let result = confirm("<i>Esta seguro de esta acción?</i>", "Confirmar");
        result.then((dialogResult) => {
            if (dialogResult) {
                closeDialog(true);
            }
        });
    }

    return (
        <div>
            <Popup
                width={600}
                height={750}
                title={`Formas de pago`}
                onHiding={onHiding}
                visible={open}
                className="bg-fbfbfb"
            >
                <ScrollView showScrollbar='never' >


                    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
                        <div className="container mx-auto px-4 py-8">
                            {/* Header */}
                            <div className="text-center mb-10 bgc-blue-100 pd-10">
                                <h2 className="color-blue">Total a Pagar</h2>
                                <h1 className="text-2xl text-gray-600">{amount.toFixed(2)}</h1>
                                <p className="text-size-md text-gray-500">Saldo Pendiente <span className="font-semibold">{saldoPendiente.toFixed(2)}</span></p>
                            </div>

                            <div className="mt-10 bgc-blue-100 pd-10">
                                <h5 className="">Agregar forma de pago</h5>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div className="d-flex">
                                        <div className="flex-1">
                                            <label>Tipo de Pago</label>
                                            <SelectBox
                                                dataSource={tiposPago}
                                                displayExpr="name"
                                                valueExpr="id"
                                                value={formData.paymentMethodId}
                                                onValueChanged={(e) => setFormData({ ...formData, paymentMethodId: e.value })}
                                                placeholder="Seleccione tipo de pago"
                                            />
                                        </div>
                                        <div className="flex-1">
                                            <label>Monto</label>
                                            <NumberBox
                                                value={formData.paymentAmount}
                                                onValueChanged={(e) => {
                                                    setFormData({ ...formData, paymentAmount: e.value });
                                                }}
                                                placeholder="0.00"
                                            />

                                        </div>
                                    </div>
                                    <div className="d-flex">
                                        <div className="flex-1">
                                            <label>Banco</label>
                                            <SelectBox
                                                dataSource={banks}
                                                displayExpr="name"
                                                valueExpr="id"
                                                disabled={formData.paymentMethodId === 1}
                                                value={formData.bankId}
                                                onValueChanged={(e) => setFormData({ ...formData, bankId: e.value })}
                                                placeholder="Seleccione banco"
                                            />
                                        </div>
                                        <div className="flex-1">
                                            <label>Referencia</label>
                                            <TextBox
                                                disabled={formData.paymentMethodId === 1}
                                                value={formData.reference}
                                                onValueChanged={(e) => setFormData({ ...formData, reference: e.value })}
                                                placeholder="Ingrese referencia"
                                            />
                                        </div>
                                    </div>
                                    <div className="d-flex">
                                        <Button
                                            text="Agregar"
                                            className='mt-10 w-100'
                                            onClick={handleAddPayment}
                                            disabled={!formData.paymentMethodId || !formData.paymentAmount}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="mt-10 bgc-blue-100 pd-10">
                                <h5 className="">Pagos registrados</h5>
                                <List
                                    dataSource={paymentList}
                                    itemRender={(item) => (
                                        <div className="d-flex justify-content-between">
                                            <div className="d-grid">
                                                <span className='text-s16'>{tiposPago.find((tipo) => tipo.id === item.paymentMethodId)?.name}</span>
                                                {item.paymentMethodId !== 1 &&
                                                    <div className="">
                                                        <span className='text-muted'>Banco: {banks.find((bank) => bank.id === item.bankId)?.name}</span>
                                                        <span className='text-muted ml-2'>Ref: {item.reference}</span>
                                                    </div>
                                                }
                                            </div>
                                            <div className="d-flex">
                                                <span className='text-s16'>{formatToMoneyNumber(item.paymentAmount)}</span>
                                                <Trash2 className="h-2 w-2" onClick={() => handleRemovePayment(item.id)} />
                                            </div>
                                        </div>
                                    )}
                                />
                            </div>
                            <p className="text-size-md text-gray-500">Cambio a devolver:
                                <span className="font-semibold ml-2">{cambio.toFixed(2)}</span>
                            </p>
                            <div className="mt-10">
                                <Button disabled={paymentList.length === 0} className='w-100' text='Confirmar pagos' onClick={handleConfirmPayments} />
                            </div>
                        </div>
                    </div>
                </ScrollView>
            </Popup>
        </div>
    );
}

export default BillPayments;
